module.exports = __webpack_public_path__ + "static/media/male-red.7accf4ed.png";